import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { Router } from '@angular/router';
import { RouteNamesEnum } from '@citizen/routes/routes';
import { IDynamicFilterModel } from '@types-custom/models/ui/dynamic-filter';
import { SearchAuditRecordService } from '@shared/services/audit-service/search-audit-record.service';
import { IGridPageModel } from '@types-custom/models/ui/grid-page-model';
import { GridTypeEnum, gridTableheadersMap } from '@shared/utils/mappers/grid-mapper';
import { BehaviorSubject, Subject } from 'rxjs';
import { IGridTableCellDispatcher } from '@types-custom/models/ui/grid-table-model';
import { SdkDynamicFiltersService } from '@sdk/services/sdk-dynamic-filters/sdk-dynamic-filters.service';
import { IAuditModel } from '@shared/models/audit.model';
import { GridAuditRecordService } from '@shared/services/audit-service/grid-audit-record.service';
import { ModalService } from '@ui-core/services/modal/modal.service';
import { IUniqueModalModel } from '@types-custom/models/ui/modal.model';
import { ModalErrorComponent } from '../modal-error/modal-error.component';

@Component({
  selector: 'search-audit-record',
  templateUrl: './search-audit-record.component.html',
  styleUrls: ['./search-audit-record.component.scss'],
})
export class SearchAuditRecordComponent implements OnInit {
  @Input() funcionality: string;
  @Output() handleValue = new EventEmitter<any>();

  Icon = Icon;
  icon = Icon.manage_accounts_w;
  layerName = GridTypeEnum.ManageRecordAudit;
  isAllowDownload = false;
  editColumnDispatcher = new Subject<IGridTableCellDispatcher>();
  dataSource = new BehaviorSubject<[]>([]);
  gridPageProps: IGridPageModel = {
    headers: gridTableheadersMap([this.editColumnDispatcher])[this.layerName],
    dataSource: this.manageAuditService,
    isAllowDownloadExcel: this.isAllowDownload,
    isAllowDownloadPdf: false,
    dispatcher: this.editColumnDispatcher
  };

  dynamicFiltersModel: IDynamicFilterModel =
    this.manageAuditService.generateDynamicFIltersModel();

  constructor(
    private router: Router,
    public manageAuditService: SearchAuditRecordService,
    private sdkDynamicFiltersService: SdkDynamicFiltersService,
    public gridAuditRecordService: GridAuditRecordService,
    private modalService: ModalService,
  ) {
    this.sdkDynamicFiltersService.setFilters(this.manageAuditService);
    this.manageAuditService.init();
    this.editColumnDispatcher.subscribe(this.handleSelectCard.bind(this));
  }

  ngOnInit(): void {

    this.gridPageProps.dataSource.data$.subscribe({
      next: (response:any) => {
        this.handleDataChange(response)
      }
    })

  }

  modalError(msg?: string) {
    const modal: IUniqueModalModel = {
      toRender: {
        component: ModalErrorComponent,
        data: { errorMessage: msg }
      },
      headerBackgroundClass: 'bg-color-background-3',
      modalClass: '#FF5B5B',
      leftLineClass: 'bg-color-state-4',
    };
    this.modalService.confirmationModal(modal);
  }

  navigateToVisor(): void {
    this.router.navigate([RouteNamesEnum.MapViewer]);
  }

  handleDataChange(data: any) {
    if (data.length === 0) {
      this.modalError('No se ha encontrado la información solicitada')
    }
  }

  handleSelectCard(columnAction: IGridTableCellDispatcher): void {
    const auditModel: IAuditModel = {
      code: this.funcionality,
      data: columnAction.row,
      renderGridRecord: true
    };
    this.gridAuditRecordService.setModelAudit(auditModel);
    this.handleValue.emit(auditModel);
  }
}
